const testimonials = [
  {
    name: "Stephanie H.",
    location: "Dunwoody, GA",
    rating: 5,
    text: "Our family cruise to the Caribbean was in 8 days and my son's passport had expired. Fast Passport Center got his expedited child passport processed in under a week. They told us exactly which clerk to visit in Dunwoody and handled everything after that.",
    service: "Child Passport",
  },
  {
    name: "David L.",
    location: "Brookhaven, GA",
    rating: 5,
    text: "Business trip to Tokyo got moved up to 4 days out. I work near Perimeter Mall in Dunwoody and didn't have time to drive downtown. Started online, shipped from Sandy Springs overnight, and had my emergency passport in 3 days. Outstanding service.",
    service: "Emergency Passport",
  },
  {
    name: "Michelle R.",
    location: "Sandy Springs, GA",
    rating: 5,
    text: "We booked a weekend getaway to Mexico and I realized my passport was damaged. Fast Passport Center walked me through the replacement process, reviewed my documents, and got me a new passport with time to spare. So grateful.",
    service: "Damaged Passport Replacement",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function DunwoodyTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What North DeKalb County Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Dunwoody, Brookhaven, Sandy Springs, and north metro Atlanta who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}